import { useQuery } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useChapterFilter = () => {
  return useQuery(
    "chapterFilter",
    async () => {
      const { data } = await axiosPost("/api/cw/viewChapterFilter");
      return data;
    },
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useChapterFilter;
